import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Directive({
  selector: '[appZipCode]',
})
export class ZipCodeDirective {
  private element: HTMLInputElement;

  constructor(private el: ElementRef, private renderer: Renderer2, private control: NgControl) {
    this.element = this.el.nativeElement;
    this.renderer.setAttribute(this.el.nativeElement, 'pattern', 'd*');
  }

  @HostListener('input')
  public onKeyUp(): void {
    const formControl: AbstractControl | null = this.control.control;
    let valueNumber = this.element.value.replace(/\D/g, '');
    if (valueNumber.length > 5) {
      valueNumber = valueNumber.substring(0, 5);
    }
    formControl?.setValue(valueNumber.toString());
  }
}
